import { useLocation, useNavigate } from 'react-router';
import { cn } from '@/shared/lib/cn';

interface SidebarItemProps {
  openSidebar: boolean;
  title?: string;
  icon?: React.ReactNode;
  path?: string;
  children?: React.ReactNode;
  drodpdown?: boolean;
  isOpen?: boolean; // <-- nuevo
  onToggle?: () => void; // <-- nuevo
  className?: string;
}

export function SidebarItem({
  openSidebar,
  title,
  icon,
  children,
  path,
  drodpdown = false,
  isOpen = false,
  onToggle,
  className,
}: SidebarItemProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (drodpdown) {
      onToggle?.();
    } else if (path) {
      navigate(path);
    }
  };

  const isActive = path && location.pathname.startsWith(path);

  return (
    <div className="h-[2.3125rem] cursor-pointer">
      {/* react-doctor-disable-next-line react-doctor/prefer-tag-over-role -- nav row already keyboard-operable (role+tabIndex+onKeyDown); converting to <button> is invasive for no a11y gain */}
      <div
        role="button"
        tabIndex={0}
        className={cn(
          'flex flex-row items-center rounded-[0.5rem] px-[0.5rem] gap-[0.75rem] h-full hover:border hover:border-primary-active',
          isActive && 'border border-primary-active',
        )}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        <div className="flex items-center gap-[0.75rem]">
          <span className="w-[1rem] h-[1rem] flex items-center justify-center">{icon}</span>
          {!openSidebar && (
            <span
              className={cn('transition-all duration-300 text-sm text-primary-color', className)}
            >
              {title}
            </span>
          )}
        </div>
        {!openSidebar && drodpdown && (
          <div className="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className={cn(
                'opacity-50 transition-transform duration-200',
                isOpen ? 'rotate-180' : 'rotate-0',
              )}
            >
              <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#3D3D3D" />
            </svg>
          </div>
        )}
      </div>
      <div
        className={cn(
          'bg-switch-thumb-disabled overflow-hidden transition-all duration-300 ease-in-out',
          isOpen ? 'max-h-108 opacity-100' : 'max-h-0 opacity-0',
        )}
      >
        {children}
      </div>
    </div>
  );
}
